/* global drift */
import React from 'react';
import PropTypes from 'prop-types';
import { ConfigureFlopFlip } from '@flopflip/react-broadcast';
import adapter from '@flopflip/launchdarkly-adapter';
import Cookies from 'js-cookie';
import { generateUUID } from 'chaoskit/src/helpers/utility';

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const scrollCheck = location => {
  return [
    '/community/tutorials/',
    '/docs/api-reference/overview/',
    '/resources/',
    '/product/',
  ].includes(location.pathname);
};

// gatsby-browser.js
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // Don't update scroll position on certain pages since we're interacting with Algolia API or Swagger API
  if (scrollCheck(location)) {
    return false;
  }

  return true;
};

// The following two functions are used to trigger a specific class used to attach the `scroll-behavior` modifier; to avoid unecessary smooth-scrolling to the top of the page between routes
export const onPreRouteUpdate = () => {
  document.documentElement.classList.remove('is-loaded');
  document.documentElement.classList.remove('has-noSmoothScroll');
};

export const onRouteUpdate = ({ location }) => {
  document.documentElement.classList.add('is-loaded');

  if (scrollCheck(location)) {
    document.documentElement.classList.add('has-noSmoothScroll');
  }

  // Drift
  // Send along page event on route change
  if (typeof drift === 'function') {
    window.drift.page();
  }

  // Pardot
  // Send along page event on route change
  if (typeof piTracker === 'function') {
    window.piTracker(location.href);
  }
};

function getUserKey() {
  const pardotCookie = Cookies.get('visitor_id481141');
  const gremlinLdCookie = Cookies.get('gremlin-ld-user');

  // First try to grab Pardot cookie; which maps to our Pardot customer database
  if (pardotCookie) {
    return pardotCookie;
  }

  // Otherwise - attempt to create our custom `gremlin-ld-user` cookie to identify users within LaunchDarkly
  if (gremlinLdCookie) {
    return gremlinLdCookie;
  }

  // Neither have been found, so let's create our own

  // Create our own cookie
  const customIdentifier = generateUUID();

  // Set cookie value
  Cookies.set('gremlin-ld-user', customIdentifier);

  // Return new value
  return customIdentifier;
}

export const wrapRootElement = ({ element }) => (
  <ConfigureFlopFlip
    adapter={adapter}
    adapterArgs={{
      clientSideId: '5cba38cbc2b5a40823c1d27f',
      clientOptions: {
        fetchGoals: true,
      },
      user: {
        key: getUserKey(),
      },
    }}
  >
    {element}
  </ConfigureFlopFlip>
);

wrapRootElement.propTypes = {
  element: PropTypes.any.isRequired,
};
